import React from 'react';

import { useFileUpload } from './data/file-upload.query';

const FileUploadPage = React.lazy(() => import('react-components/src/shared/file-upload-page'));

const FileUploadsRoutes = () => (
  <FileUploadPage
    configuration={{
      pathname: '/file-uploads/:id',
      title: 'File Upload',
      redirect: {
        useData: () => ({ url: useFileUpload().url }),
      },
    }}
  />
);

export default FileUploadsRoutes;
